import { toggleNode } from './toggle-node';
import { updateNodeState } from './update-node-state';
/**
 * 切换子节点状态
 * @param children 子节点列表
 * @param checked 是否选中
 * @returns 更新后的子节点列表
 */
export function toggleChildrenState(children, checked) {
    if (!children || children.length === 0) {
        return children;
    }
    return children.map(function (child) {
        if (!child.disabled) {
            var toggledChild = toggleNode(child, checked);
            return updateNodeState(toggledChild);
        }
        return child;
    });
}
